import { useState } from "react";
import {
    FaLanguage,
    FaCheckCircle,
} from "react-icons/fa";

import "./CustomerLanguageSettings.css";

function CustomerLanguageSettings() {

    const [selected, setSelected] = useState("English");

    const languages = [

        {
            name: "English",
            native: "English",
        },

        {
            name: "Kannada",
            native: "ಕನ್ನಡ",
        },

        {
            name: "Hindi",
            native: "हिन्दी",
        },

        {
            name: "Telugu",
            native: "తెలుగు",
        },

        {
            name: "Tamil",
            native: "தமிழ்",
        },

        {
            name: "Malayalam",
            native: "മലയാളം",
        },

    ];

    return (

        <div className="language-page">

            <div className="language-header">

                <FaLanguage />

                <div>

                    <h2>

                        Language

                    </h2>

                    <p>

                        Select your preferred language.

                    </p>

                </div>

            </div>

            <div className="language-card">

                {

                    languages.map((language) => (

                        <div
                            key={language.name}
                            className={`language-item ${
                                selected === language.name
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() =>
                                setSelected(language.name)
                            }
                        >

                            <div>

                                <h4>

                                    {language.name}

                                </h4>

                                <span>

                                    {language.native}

                                </span>

                            </div>

                            {

                                selected === language.name && (

                                    <FaCheckCircle />

                                )

                            }

                        </div>

                    ))

                }

            </div>

        </div>

    );

}

export default CustomerLanguageSettings;